import {
    GET_SUPPLIER_POS,
    PO_PURCHACE_ORDER_LIST,
    REQUEST_PO_PURCHACE_ACTION,
    PO_PURCHACE_ORDER_LIST_FOR_VENDOR,
    CHANGE_SUPPLIER_DOCUMENT_STATUS,
} from '../type'

const initialState = {
    loading: true,
    pos: [],
}

export default function supplierReducer(state = initialState, action) {
    switch (action.type) {

        case GET_SUPPLIER_POS:
            return {
                ...state,
                pos: action.payload,
                loading: false

            }
        // break;
        case PO_PURCHACE_ORDER_LIST:
            return {
                ...state,
                pos_lists: action.payload,
                loading: false
            }

        case REQUEST_PO_PURCHACE_ACTION:
            return {
                ...state,
                pos_acceptance_action: action.payload,
                loading: false
            }
        case PO_PURCHACE_ORDER_LIST_FOR_VENDOR:
            return {
                ...state,
                pos_lists_for_vendor: action.payload,
                loading: false
            }
        case CHANGE_SUPPLIER_DOCUMENT_STATUS:
            return {
                ...state,
                loading: false

            }
        default: return state
    }

}